import styles from "../../pages/contact-us/contact-us.module.css";
const pin = "../../assets/images/contact/pin.png";
const call = "../../assets/images/contact/call.png";
const mail = "../../assets/images/contact/mail.png";
const redrightarrow = "../../assets/images/contact/redrightarrow.png";
import dynamic from 'next/dynamic';
const Image = dynamic(() => import("next/image"));
const Link = dynamic(() => import("next/link"));

const BranchAddressTNPSC = () => {  
  
     const contactcontent = [
    {
      heading: "Shankar IAS Academy - Head Office",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,  
      address:
        "Door No 18, Old plot No 109,<br/>AL Block, 4th Avenue,<br/>Anna Nagar, Chennai - 600040",
      phones: [
        { label: "", number: "9003190030" }
      ],
      email: "enquiry@shankarias.in",
      url: "https://www.google.com/maps/place/Shankar+IAS+Academy+Chennai+-+IAS+Academy+in+Chennai+%7C+Best+UPSC+Coaching+Centre/@13.0820596,80.2030261,14.75z/data=!4m6!3m5!1s0x3a52654d8fc25ff7:0x9b278e8700a30d6!8m2!3d13.0823643!4d80.2047976!16s%2Fg%2F11fjr76z1j?hl=en",
      url1: "https://www.google.com/maps/place/Shankar+IAS+Academy+Chennai+-+IAS+Academy+in+Chennai+%7C+Best+UPSC+Coaching+Centre/@13.0820596,80.2030261,14.75z/data=!4m6!3m5!1s0x3a52654d8fc25ff7:0x9b278e8700a30d6!8m2!3d13.0823643!4d80.2047976!16s%2Fg%2F11fjr76z1j?hl=en"
    },

     { heading: "TNPSC/Banking/SSC Class Building",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,  
      address:
       "TNPSC - Block ( Manasarovar ), No. 255 , AL Block , 4th Avenue, Shanthi colony,<br/>  Anna Nagar,Chennai - 600040",
      phones: [
        { label: "", number: "044-43533445"},
        { label: "", number: "044-45543082"},
        { label: "", number: "7667766266"}
      ],
      email: "enquiry@shankarias.in",
      url: "google.com/maps/place/Shankar+IAS+Academy/@13.0819136,80.2038534,19z/data=!4m6!3m5!1s0x3a526411db99fa8d:0x96a212b8790c0ab2!8m2!3d13.082536!4d80.2051886!16s%2Fg%2F11h7rr2c96?authuser=0&entry=tts&g_ep=EgoyMDI1MDgxOS4wIPu8ASoASAFQAw%3D%3D&skid=90375baa-cf64-4d59-b790-0c8133bcb6da",
      url1: "google.com/maps/place/Shankar+IAS+Academy/@13.0819136,80.2038534,19z/data=!4m6!3m5!1s0x3a526411db99fa8d:0x96a212b8790c0ab2!8m2!3d13.082536!4d80.2051886!16s%2Fg%2F11h7rr2c96?authuser=0&entry=tts&g_ep=EgoyMDI1MDgxOS4wIPu8ASoASAFQAw%3D%3D&skid=90375baa-cf64-4d59-b790-0c8133bcb6da"
     },
    
    {
      heading: "Delhi",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,   
      address:
        "No.25, 2nd Floor, Pusa Road,<br/>Karol Bagh, Delhi - 110005",
      phones: [
        { label: "", number: "88991 80180" }
      ],
      email: "delhi@shankarias.in",
      url: "https://goo.gl/maps/Tf5Ji7ywXKf9Jg3A7",
      url1: "https://goo.gl/maps/Tf5Ji7ywXKf9Jg3A7"
    },
    {
      heading: "Adyar",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,
      address:
        "No-2/23, 3rd Cross Street,<br/>Adyar, Chennai - 600020",
      phones: [
        { label: "", number: "9025278278" }
      ],
      email: "adyarsia@shankariasacad.in",
      url: "https://goo.gl/maps/SMh8sACtbCwetN596",
      url1: "https://goo.gl/maps/SMh8sACtbCwetN596"
    },

    {
      heading: "Bengaluru",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,
      address:
        "No-34, 2nd stage, <br/>Basaveshwara HBCS layout,<br/>Chandra layout bus stand road,<br/> Bengaluru, Karnataka - 560040 <br/> Landmark: Opposite to Karur Vysya Bank",
      phones: [
        { label: "", number: "72593 23266" },
        { label: "", number: "080-23383121" },
        { label: "", number: "81972 92121" }
      ],
      email: "siabengaluru@shankariasacad.in",
      url: "https://goo.gl/maps/CCGtnnwAF772VBwcA",
      url1: "https://goo.gl/maps/CCGtnnwAF772VBwcA"
    },

    {
      heading: "Thiruvananthapuram",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,
      address:
        "2nd floor, Condor Plaza, TC 2/2421,<br/> Pattom Palace P.O.,<br/>Thiruvananthapuram, <br/>Kerala - 695004",
      phones: [
        { label: "", number: "79949 36555" },
        { label: "", number: "75919 02600" },
      ],
      email: "siatrivandrum@shankarias.in",
      url: "https://goo.gl/maps/id9z1EDWhVfqJUVW9",
      url1: "https://goo.gl/maps/id9z1EDWhVfqJUVW9"
    },

    {
      heading: "Hyderabad",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,
      address:
        "4th floor, Pasham Amrutha Ram Residency, Municipal No :1-2-234/13/46/4,<br/>Near bake zone bakery, Domalguda,<br/> Arvind nagar, Himayathnagar,<br/>Hyderabad, Telangana - 500029",
      phones: [
        { label: "", number: "83091 25825" }
      ],
      email: "hyderabad@shankarias.in",
      url: "https://www.google.com/maps/place/Shankar+IAS+Academy+Hyderabad/@17.4097882,78.487221,17z/data=!3m1!4b1!4m6!3m5!1s0x8322f8764aad961:0xf0a187bddb107656!8m2!3d17.4097882!4d78.487221!16s%2Fg%2F11kqm5fnmd?entry=ttu&g_ep=EgoyMDI2MDIxMC4wIKXMDSoASAFQAw%3D%3D",
      url1: "https://www.google.com/maps/place/Shankar+IAS+Academy+Hyderabad/@17.4097882,78.487221,17z/data=!3m1!4b1!4m6!3m5!1s0x8322f8764aad961:0xf0a187bddb107656!8m2!3d17.4097882!4d78.487221!16s%2Fg%2F11kqm5fnmd?entry=ttu&g_ep=EgoyMDI2MDIxMC4wIKXMDSoASAFQAw%3D%3D"
    },

    {
      heading: "Madurai",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,
      address:
        "Plot no:409, B Mall super market, Second floor, church road,Anna Nagar, Sathamangalam, Madurai - 625020 <br/> Landmark: Near Suguna stores bus stop, Second left towards Ambiga College",
      phones: [ 
        { label: "", number: "97896 22555" },
        { label: "", number: "0452-4255455" }
      ],
      email: "maduraisia@shankariasacad.in",
      url: "https://goo.gl/maps/gtj5zwr9tg2saZU97",
      url1: "https://goo.gl/maps/gtj5zwr9tg2saZU97"
    },

    {
      heading: "Salem",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,
      address:
        "No.207/5 United Arcade, Kauveri Avenue,<br/>State Bank Colony, Junction Main Road,<br/> Salem - 636 004",
      phones: [
        { label: "", number: "0427-2441961" },
        { label: "", number: "89400 80039" }
      ],
      email: "salemsia@shankariasacad.in",
      url: "https://goo.gl/maps/NjfQjqauCjwEGjQaA",
      url1: "https://goo.gl/maps/NjfQjqauCjwEGjQaA"
    },

    {
      heading: "Trichy",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,
      address:
        "N.R.Towers, A9 (N), Salai Road, Thillai Nagar,<br/>Trichy - 620 018 <br/> Landmark: LIC -Rock Fort Branch Building",
      phones: [ 
        { label: "", number: "0431-4976911" },
        { label: "", number: "97896 64555" }
      ],
      email: "trichy@shankarias.in",
      url: "https://goo.gl/maps/bom1j7BjxF3pH4827",
      url1:"https://goo.gl/maps/bom1j7BjxF3pH4827"
    },

    // {
    //   heading: "UPSC - Coimbatore",
    //   Image: pin,
    //   Image1: call,
    //   Image2: mail,
    //   Image3: redrightarrow,
    //   address:
    //     "Gayathri Building-2nd Floor, Old # 220B, New# 149B, Dr.Rajendraprasad Road <br/> (100 ft Road),Coimbatore - 641012 <br/>Landmark:Above Prince Jewellery ",
    //   phones: [
    //     { label: "", number: "98898 98868" },
    //     { label: "", number: "94892 22761" }
    //   ],
    //   email: "siaupsccoimbatore@shankariasacad.in",
    //   url: "",
    //   url1: ""
    // },

    {
      heading: "TNPSC - Gandhiupuram - Coimbatore",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,
      address:
        "No.790, 2nd Floor, Cross Cut Road, Gandhipuram (Next to Josco Jewellers), Coimbatore-641 012.",
      phones: [
        { label: "", number: "99945 51898" },
        { label: "", number: "94892 22761" }
      ],
      email: "covai@shankarias.in",
      url: "https://goo.gl/maps/NPMuVydGTEAEZnJP8",
      url1: "https://goo.gl/maps/NPMuVydGTEAEZnJP8"
    },

    {
      heading: "TNPSC - Peelamedu - Coimbatore",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,
      address:
        "No.268 A, First Main Road , Anna Nagar ,Peelamedu, Coimbatore - 641004.",
      phones: [
        { label: "", number: "7305951898" },
        { label: "", number: "7845822761" }
      ],
      email: "covai@shankarias.in",
      url: "",
      url1: ""
    },

    {
      heading: "Namakkal",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,
      address:
        "Bank of Baroda Backside, Cheran Towers,Block No -2/67, 1st Floor ( West ) , Thillaipuram Main Road, ParamathiRd,Namakkal-637 001.",
      phones: [   
        { label: "", number: "99944 34921" },
        { label: "", number: "04286-223007" }
      ],
      email: "namakkalsia@shankariasacad.in",
      url: "https://www.google.com/maps/place/Shankar+IAS+Academy+Namakkal+-+TNPSC+Coaching+Centre/@11.2183059,78.1630065,17z/data=!4m6!3m5!1s0x3babcfcfd7c57b5d:0x13a7e73738a32d85!8m2!3d11.2183006!4d78.1655814!16s%2Fg%2F11tp4wtm49?entry=tts&g_ep=EgoyMDI1MDQwMi4xIPu8ASoASAFQAw%3D%3D&skid=59c4fdab-784e-4ca1-a3fa-4b7e97754403",
      url1: "https://www.google.com/maps/place/Shankar+IAS+Academy+Namakkal+-+TNPSC+Coaching+Centre/@11.2183059,78.1630065,17z/data=!4m6!3m5!1s0x3babcfcfd7c57b5d:0x13a7e73738a32d85!8m2!3d11.2183006!4d78.1655814!16s%2Fg%2F11tp4wtm49?entry=tts&g_ep=EgoyMDI1MDQwMi4xIPu8ASoASAFQAw%3D%3D&skid=59c4fdab-784e-4ca1-a3fa-4b7e97754403"
    },

    {
      heading: "Thiruvarur",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,
      address:
       "3/310/7 GTN Complex, Mannai salai, (Opp to State Bank of India), Vilamal, Thiruvarur-610 001.",
      phones: [ 
        { label: "", number: "97877 34943" },
        { label: "", number: "70102 62725" }
      ],
      email: "thiruvarur@shankarias.in",
      url: "",
      url1: ""
    },

    {
      heading: "Study Materials Office",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,
      address:
        "AL 19, Flat 110, Shanthi Colony,<br/> [Next to Shankar IAS Academy] <br/>Anna Nagar, Chennai–600 040",
      phones: [ 
        { label: "Anna Nagar", number: "044 45512113" },
        { label: "Anna Nagar", number: "99624 86468" },
        { label: "Adyar", number: "90872 37000" },

      ],
      email: "study@shankarias.in",
      url: "https://www.google.com/maps/place/Shankar+IAS+Academy+Chennai/@13.0800053,80.2011141,17z/data=!4m6!3m5!1s0x3a52654d8fc25ff7:0x9b278e8700a30d6!8m2!3d13.0823643!4d80.2047976!16s%2Fg%2F11fjr76z1j?hl=en&entry=ttu&g_ep=EgoyMDI2MDIxMC4wIKXMDSoASAFQAw%3D%3D",
      url1: "https://www.google.com/maps/place/Shankar+IAS+Academy+Chennai/@13.0800053,80.2011141,17z/data=!4m6!3m5!1s0x3a52654d8fc25ff7:0x9b278e8700a30d6!8m2!3d13.0823643!4d80.2047976!16s%2Fg%2F11fjr76z1j?hl=en&entry=ttu&g_ep=EgoyMDI2MDIxMC4wIKXMDSoASAFQAw%3D%3D"
    },


  ];

  // const contactcontent = [
  //   {
  //       heading: "Shankar IAS Academy - Head Office", Image: pin, address: (<><div> Door No 18, Old plot No 109, New plot No 259,</div> <div>AL Block, 4th Avenue, Shanthi Colony,</div> <div>Anna Nagar, Chennai-600 040.</div> </>), Image1: call, mobileno1: "90031 90030", Image2: mail, mailid: "enquiry@shankarias.in", direction: "Get Directions", Image3: redrightarrow,
  //       url: "https://www.google.com/maps/place/Shankar+IAS+Academy+Chennai+-+IAS+Academy+in+Chennai+%7C+Best+UPSC+Coaching+Centre/@13.0820596,80.2030261,14.75z/data=!4m6!3m5!1s0x3a52654d8fc25ff7:0x9b278e8700a30d6!8m2!3d13.0823643!4d80.2047976!16s%2Fg%2F11fjr76z1j?hl=en",
  //       url1: "https://www.google.com/maps/place/Shankar+IAS+Academy+Chennai+-+IAS+Academy+in+Chennai+%7C+Best+UPSC+Coaching+Centre/@13.0820596,80.2030261,14.75z/data=!4m6!3m5!1s0x3a52654d8fc25ff7:0x9b278e8700a30d6!8m2!3d13.0823643!4d80.2047976!16s%2Fg%2F11fjr76z1j?hl=en"
  //     },

  //   { heading: "TNPSC/Banking/SSC Class Building", Image: pin, address:(<><div>TNPSC - Block ( Manasarovar ),</div> <div>No. 255 , AL Block , 4th Avenue,</div> <div> Shanthi colony, Anna Nagar,</div> <div> Chennai - 600 040.</div> </>), Image1: call, mobileno: "76677 66266", mobileno1: "044-45543082", mobileno2: "044-45543082", Image2: mail, mailid: "enquiry@shankarias.in", direction: "Get Directions", Image3: redrightarrow,
  //    url: "https://maps.app.goo.gl/8a7QqFc91dpne9zQA",
  //    url1: "https://maps.app.goo.gl/8a7QqFc91dpne9zQA" },

  //   { heading: "Adyar", Image: pin, address: (<> <div>No-2/23, 3rd Cross Street,</div> <div>Padmanabhanagar, Adyar,</div> <div> Chennai-600 020.</div> </>), Image1: call, mobileno: "90252 78278", Image2: mail, mailid: "adyarsia@shankariasacad.in", direction: "Get Directions", Image3: redrightarrow, url: "https://goo.gl/maps/SMh8sACtbCwetN596", url1: "https://goo.gl/maps/SMh8sACtbCwetN596" },
  //   { heading: "Salem", Image: pin, address: "No.207/5 United Arcade, Kauveri Avenue, State Bank Colony, Junction Main Road, Salem-636 004.", Image1: call, mobileno: "0427-2441961", mobileno1: "89400 80039", Image2: mail, mailid: "salemsia@shankarias.in", direction: "Get Directions", Image3: redrightarrow, url: "https://goo.gl/maps/NjfQjqauCjwEGjQaA", url1: "https://goo.gl/maps/NjfQjqauCjwEGjQaA" },
  //   { heading: "Madurai Admission Office", Image: pin, address: "Plot no:409/B, Mall super market, Second floor, church road, Anna Nagar, Sathamangalam, Madurai-625 020.", address2: "Landmark : Near Suguna stores bus stop, Second left towards Ambiga College", Image1: call, mobileno: "97896 22555", mobileno1: "0452-4255455", Image2: mail, mailid: "maduraisia@shankariasacad.in", direction: "Get Directions", Image3: redrightarrow, url: "https://goo.gl/maps/gtj5zwr9tg2saZU97", url1: "https://goo.gl/maps/gtj5zwr9tg2saZU97" },
  //   { heading: "Madurai", Image: pin, address: "340 MIG Colony, GSP Plaza, Bata show room, 5th floor, Anna Nagar, Sathamangalam, Madurai-625020.", Image1: call, mobileno: "97896 22555", mobileno1: "0452-4255455", Image2: mail, mailid: "maduraisia@shankariasacad.in", direction: "Get Directions", Image3: redrightarrow, url: "https://goo.gl/maps/gZKdBykZPjXt6rx2A", url1: "https://goo.gl/maps/gZKdBykZPjXt6rx2A" },
  //   { heading: "Trichy", Image: pin, address: "N.R.Towers, A9 (N), Salai Road, Thillai Nagar, Trichy-620 018.", address2: "Landmark: LIC -Rock Fort Branch Building", Image1: call, mobileno: "0431-4976911", mobileno1: "97896 64555", Image2: mail, mailid: "trichy@shankarias.in", direction: "Get Directions", Image3: redrightarrow, url: "https://goo.gl/maps/bom1j7BjxF3pH4827", url1: "https://goo.gl/maps/bom1j7BjxF3pH4827" },
  //   { heading:"UPSC-Coimbatore", Image: pin, address: "Gayathri Building-2nd Floor,<br />Old # 220B, New# 149B,<br />Dr.Rajendraprasad Road (100 ft Road),Coimbatore - 641012 ",address2: "Landmark:Above Prince Jewellery ", Image1: call, mobileno: "98898 98868", mobileno1: "", Image2: mail, mailid: "siaupsccoimbatore@shankariasacad.in", direction: "", Image3: redrightarrow, url: "", url1: "" },
  //   { heading: "TNPSC - Gandhiupuram - Coimbatore", Image: pin, address: "No.790, 2nd Floor, Cross Cut Road, Gandhipuram (Next to Josco Jewellers), Coimbatore-641 012.", Image1: call, mobileno: "99945 51898 | 94892 22761", mobileno1: "", Image2: mail, mailid: "covai@shankarias.in", direction: "Get Directions", Image3: redrightarrow, url: "https://goo.gl/maps/NPMuVydGTEAEZnJP8", url1: "https://goo.gl/maps/NPMuVydGTEAEZnJP8" },
  //   { heading: "TNPSC - Peelamedu - Coimbatore", Image: pin, address: "No.268 A, First Main Road , Anna Nagar , Peelamedu, Coimbatore - 641004.", Image1: call, mobileno: "7305951898", mobileno1: "7845822761", Image2: mail, mailid: "covai@shankarias.in", direction: "", Image3: redrightarrow, url: "", url1: "" },
  //   { heading: "Namakkal", Image: pin, address: "Block No -2/67, 1st Floor ( West ) , Thillaipuram Main Road, Namakkal-637 001.", Image1: call, mobileno: "99944 34921", mobileno1: "04286-223007", Image2: mail, mailid: "sianamakkal@shankarias.in", direction: "Get Directions", Image3: redrightarrow, url: "https://goo.gl/maps/J2wbzRjw8N8akLtt7", url1: "https://goo.gl/maps/J2wbzRjw8N8akLtt7" },
  //   { heading: "Thiruvarur", Image: pin, address: "3/310/7 GTN Complex, Mannai salai, <br /> (Opp to State Bank of India), Vilamal, Thiruvarur-610 001.", Image1: call, mobileno: "97877 34943", mobileno1: "70102 62725", Image2: mail, mailid: "thiruvarur@shankarias.in", direction: "", Image3: redrightarrow, url: "", url1: "" },
  //   { heading: "Study Materials Office", Image: pin, address: "AL 19, Flat 110, Shanthi Colony, [Next to Shankar IAS Academy] Anna Nagar, Chennai–600 040", Image1: call, annanager: "Anna Nagar: ", adyar: "Adyar: ", mobileno: "044 45512113 | 99624 86468", mobileno1: "90872 37000", Image2: mail, mailid: "postal@shankarias.in", direction: "Get Directions", Image3: redrightarrow, url: "https://goo.gl/maps/QVwrJE4oqkmvUg747", url1: "https://goo.gl/maps/QVwrJE4oqkmvUg747" },
  // ]


  return (
    <>

    <section id="tnpsccentres">
      <div className="container-fluid" style={{ background: '#E2F6FF 0% 0% no-repeat padding-box' }}>
        <div className="row">
          <div className="col py-5 px-0">

            <div className="container">
              <div className="row">
                <div className="col">
                  <h2 className={`${styles.sectiontitle}`}>Our Branches</h2>
                </div>
              </div>
            </div>

            <div className="container pt-3">
              <div className="row">

                <div className="col">
                  <div className="row">

                    {contactcontent.map((item, index) => (
                       <div className="col-md-6 col-lg-4 col-12 mb-3">
                          <div className={`${styles.contactbox} h-100`}>
                            <div className={`${styles.contactboxheight} px-4 pt-4 pt-md-5`}>

                              {/* Heading */}
                              <div className={`${styles.acheivername2} mb-3`}>
                                {item.heading}
                              </div>

                              {/* Address */}
                              <div className="row">
                                <div className="col-1 pe-0">
                                  <Image src={item.Image} width={14} height={14} alt="location" />
                                </div>
                                <div className="col-11">
                                  {item.address && (
                                    <div
                                      className={styles.acheiverrank}
                                      dangerouslySetInnerHTML={{ __html: item.address }}
                                    />
                                  )}
                                  {item.address1 && (
                                    <div className={styles.acheiverrank}>
                                      {item.address1}
                                    </div>
                                  )}
                                  {item.address2 && (
                                    <div className={styles.contactsubcontent}>
                                      {item.address2}
                                    </div>
                                  )}
                                </div>
                              </div>

                              {/* Phone Numbers */}
                              {item.phones?.length > 0 && (
                                <div className="row mt-2">
                                  <div className="col-1 pe-0 d-flex align-items-start">
                                    <Image
                                      src={item.Image1}
                                      width={16}
                                      height={16}
                                      alt="phone"
                                    />
                                  </div>

                                  <div className="col-11">
                                    {item.phones?.map((phone, index) => (
                                      <div key={index} className="mb-1">
                                        <a
                                          href={`tel:${phone.number.replace(/[^0-9]/g, "")}`}
                                          className={styles.mobilemaillinks}
                                        >
                                          {phone.number}
                                        </a>
                                      </div>
                                    ))}
                                  </div>
                                </div>

                              )}

                              {/* Email */}
                              {item.email && (
                                <div className="row mt-2">
                                  <div className="col-1 pe-0">
                                    <Image src={item.Image2} width={14} height={14} alt="email" />
                                  </div>
                                  <div className="col-11">
                                    <p className={styles.acheiverrank}>
                                      <a
                                        href={`mailto:${item.email}`}
                                        className={styles.mobilemaillinks}
                                      >
                                        {item.email}
                                      </a>
                                    </p>
                                  </div>
                                </div>
                              )}
                            </div>

                            {/* ===== Direction + Arrow Section ===== */}
                            {(item.url || item.url1) && (
                              <>
                                <hr className="mb-0" />
                                <div className="px-4 pb-1 py-md-2">
                                  <div className="row align-items-center">
                                    
                                    {/* Direction Text */}
                                    <div className="col-9 col-xl-10">
                                      {item.url && (
                                        <Link
                                          href={item.url}
                                          target="_blank"
                                          className={styles.redunderline}
                                        >
                                          {item.direction || "Get Directions"}
                                        </Link>
                                      )}
                                    </div>

                                    {/* Arrow Image */}
                                    <div className="col-3 col-xl-2 text-end">
                                      {item.url1 && item.Image3 && (
                                        <Link href={item.url1} target="_blank">
                                          <Image
                                            src={item.Image3}
                                            width={30}
                                            height={30}
                                            className={`${styles.img} img-fluid`}
                                            alt="arrow"
                                          />
                                        </Link>
                                      )}
                                    </div>

                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                      </div>
                    ))}


                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
    </>
  )
}

export default BranchAddressTNPSC